// React
import { useState } from "react";
// Third-Party =====> react-router-dom
import { Link } from "react-router-dom";
// Third-Party =====> bootstrap
import { Container, Nav, Navbar } from "react-bootstrap";
// Images
import logo from "../assets/logo.png";

const Header = () => {
   // ################### REACT HOOKS ###################
   const [expanded, setExpanded] = useState(false);

   // TODO: Create an array of all link in staticData file then import it to here.
   return (
      <div className="landing">
         <Navbar
            collapseOnSelect
            expanded={expanded}
            expand="lg"
            variant="dark"
            bg="transparent"
         >
            <Container>
               <Navbar.Brand href="/">
                  <img src={logo} alt="MATRIX" />
               </Navbar.Brand>
               <Navbar.Toggle
                  onClick={() => setExpanded(expanded ? false : "expanded")}
                  aria-controls="responsive-navbar-nav"
                  className="item-nav"
               />
               <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav>
                     <Nav.Link
                        as={Link}
                        to="/"
                        onClick={() => setExpanded(false)}
                     >
                        الرئيسية
                     </Nav.Link>
                     <Nav.Link
                        href="/#land-slider"
                        onClick={() => setExpanded(false)}
                     >
                        ميزاتنا
                     </Nav.Link>

                     <Nav.Link
                        href="/#services"
                        onClick={() => setExpanded(false)}
                     >
                        الخدمات
                     </Nav.Link>
                     <Nav.Link
                        href="/#works"
                        onClick={() => setExpanded(false)}
                     >
                        اعمالنا
                     </Nav.Link>
                     {/* <Nav.Link
                        as={Link}
                        to="/partners"
                        onClick={() => setExpanded(false)}
                     >
                        شركاء الاعمال
                     </Nav.Link> */}
                     <Nav.Link
                        as={Link}
                        to="/career"
                        onClick={() => setExpanded(false)}
                     >
                        الوظائف
                     </Nav.Link>
                     <Nav.Link
                        as={Link}
                        to="/about"
                        onClick={() => setExpanded(false)}
                     >
                        من نحن؟
                     </Nav.Link>

                     <Nav.Link
                        href="/#contact-comp"
                        onClick={() => setExpanded(false)}
                     >
                        تواصل معنا
                     </Nav.Link>
                  </Nav>
                  <Nav></Nav>
               </Navbar.Collapse>
            </Container>
         </Navbar>
      </div>
   );
};

export default Header;
